import { render, staticRenderFns } from "./TelemedicineWorkOrder.vue?vue&type=template&id=24b933d2&scoped=true"
import script from "./TelemedicineWorkOrder.vue?vue&type=script&lang=js"
export * from "./TelemedicineWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./TelemedicineWorkOrder.vue?vue&type=style&index=0&id=24b933d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b933d2",
  null
  
)

export default component.exports